import { createContentDeliveryClient } from './axiosClient';

export const getContent = async ( contentId ) => {
  const client = createContentDeliveryClient();
  const response = await client.get(encodeURIComponent(contentId));
  return response.data;
};

export const getContentWithChildren = async ( contentId ) => {
  const client = createContentDeliveryClient();
  const response = await client.get(`${encodeURIComponent(contentId)}`, {
    params: {
      expand: '*'
    }
  });
  return response.data;
}

export const getContentChildren = async ( contentId ) => {
  const client = createContentDeliveryClient();
  const response = await client.get(`${encodeURIComponent(contentId)}/children`, {
    params: {
      expand: '*'
    }
  });
  return response.data;
}